import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-[100dvh] flex items-center justify-center bg-[#0A1128] text-slate-300">
                <Loader2 className="w-5 h-5 animate-spin mr-2" />
                Loading…
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/" state={{ from: location.pathname }} replace />;
    }

    return children;
}
